(function() {
  const regua = document.querySelector('.afericao-regua-lateral');
  if (!regua) return;

  const dots = Array.from(regua.querySelectorAll('.afericao-regua-lateral__dot'));
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Resolve o target real: ID literal ou wrapper Shopify com sufixo
  function resolveTarget(href) {
    if (!href || !href.startsWith('#')) return null;
    const name = href.slice(1);
    return document.getElementById(name) || document.querySelector('[id$="__' + name + '"]');
  }

  // Descobre cor de fundo "real" descendo na árvore se necessário
  function findOpaqueBg(rootEl) {
    const tryGet = function(el) {
      const bg = getComputedStyle(el).backgroundColor;
      const m = bg.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)$/);
      if (!m) return null;
      const a = m[4] === undefined ? 1 : parseFloat(m[4]);
      if (a < 0.5) return null;
      return { r: +m[1], g: +m[2], b: +m[3] };
    };
    // Tenta o próprio root, depois filhos diretos, depois descendentes amplos
    const direct = [rootEl].concat(Array.from(rootEl.children || []));
    for (let i = 0; i < direct.length; i++) {
      const bg = tryGet(direct[i]);
      if (bg) return bg;
    }
    const all = rootEl.querySelectorAll('*');
    for (let i = 0; i < all.length; i++) {
      const bg = tryGet(all[i]);
      if (bg) return bg;
    }
    return { r: 255, g: 255, b: 255 };
  }

  // YIQ luminance (W3C) → > 128 = fundo claro
  function isLightBg(rgb) {
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000 > 128;
  }

  // Filtra dots cujo target não existe no DOM (proteção)
  const validDots = dots.filter(function(dot) {
    const target = resolveTarget(dot.getAttribute('href'));
    if (!target) {
      dot.remove();
      return false;
    }
    dot.dataset.targetId = target.id;
    return true;
  });

  if (validDots.length === 0) {
    regua.style.display = 'none';
    return;
  }

  // Click → scroll suave
  validDots.forEach(function(dot) {
    dot.addEventListener('click', function(e) {
      e.preventDefault();
      const target = resolveTarget(this.getAttribute('href'));
      if (!target) return;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });

  // Intersection Observer → atualiza dot ativo + cor adaptativa
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        validDots.forEach(function(d) {
          d.classList.toggle('is-active', d.dataset.targetId === entry.target.id);
        });
        const bg = findOpaqueBg(entry.target);
        regua.classList.toggle('on-light', isLightBg(bg));
      }
    });
  }, {
    rootMargin: '-40% 0px -40% 0px',
    threshold: 0
  });

  validDots.forEach(function(dot) {
    const target = resolveTarget(dot.getAttribute('href'));
    if (target) observer.observe(target);
  });
})();